<template>
  <div>
    <div class="level">
      <div class="level-left">
        <div class="has-text-grey">
          <nav
            class="breadcrumb
              has-succeeds-separator
              is-marginless
              has-background-white">
            <ul class="margin-zero">
              <li
                :class = "{ 'margin25' : index == 0 }"
                v-for="(level, index) in levels"
                :key="level.to.query.childLevel"
              >
                <router-link
                  :class="{disabled: level.to  && levels.length == (index + 1)}"
                  :to="{ name: level.to.name,
                  query: level.to.query,
                  params: level.to.params}">
                  <span class="font-weight-bold w-fixed text-truncate"
                    :title="level.text">
                    {{ level.text }}
                  </span>
                </router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="level-right" :class="{ 'disabled-icon': disableEdits }">
        <a
          :class="{ 'disabled-icon': disableEdits }"
          @click="toggleAdd">
          <font-awesome-icon
            :icon="['fal', 'plus']"
            class="has-text-primary"
            :class="{ 'disabled-icon': disableEdits }"
          />
          Add Location
        </a>
      </div>
    </div>
    <div class="row-add" v-if="this.isAdding === true">
      <div class="align-left has-text-grey is-italic">
        Please select a location to add to the location list.
      </div>

      <div class="add-container wrap">
        <div class="flex-item grow">
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Location</label>
            </div>
            <div class="field-body">
              <div class="field has-addons">
                <div class="control is-expanded">
                  <popper
                    ref="locationSearch"
                    trigger="click"
                    :options="{
                      placement: 'bottom',
                      priority: 'bottom',
                      arrow: false,
                    }">
                    <div class="popper">
                      <div
                        class="search-result"
                        @click="stageLocation(searchResult)"
                        v-for="searchResult in searchResults.data"
                        :key="searchResult.stateLocationId">
                        <span>
                          {{ searchResult.stateLocationId }} - {{ searchResult.location.name}}
                          ({{ searchResult.localCode }}) - {{ searchResult.street1}}
                          {{ searchResult.city }}, {{ searchResult.stateCode }}
                        </span>
                      </div>
                    </div>
                    <input
                      slot="reference"
                      class="input location-search"
                      :class="{ 'is-danger': hasErrorName }"
                      v-model="searchName"
                      type="text"
                      placeholder="Search Location"
                      @keyup="checkLength"/>
                  </popper>
                  <p class="help is-danger">{{ nameMsg }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-item">
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Start Date</label>
            </div>
            <div class="field-body">
              <div class="content is-paddingless">
                <div class="field">
                  <div class="control">
                    <input
                      class="calendar"
                      :class="{ 'is-danger': hasErrorDate }"
                      v-model="startDate"
                      type="date">
                  </div>
                  <p class="help is-danger">{{ dateMsg }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <br>

        <div class="flex-item">
          <div class="field is-grouped">
            <div class="control  is-flex align-center">
              <a @click="cancelAdd">Cancel</a>
            </div>
            <div class="control">
              <button
                class="button is-primary"
                @click.stop.prevent="formValidation">
                  Add Location
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faPlus,
} from '@fortawesome/pro-light-svg-icons';
import popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
import GroupLevelManager from '@/mixins/GroupLevelManager';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faPlus,
);

export default {
  mixins: [GroupLevelManager, NotificationManager],
  props: ['disableEdits', 'location', 'childLevel', 'parentId'],
  components: {
    popper,
  },
  data() {
    return {
      searchName: null,
      refName: null,
      searchResults: [],
      isAdding: false,
      locationId: null,
      startDate: new Date().toISOString().substr(0, 10),
      timeout: null,
      hasErrorName: false,
      hasErrorDate: false,
      nameMsg: null,
      dateMsg: null,
    };
  },
  methods: {
    cancelAdd() {
      this.toggleAdd();
      this.resetErrors();
      this.resetForm();
    },
    resetForm() {
      this.searchName = null;
      this.startDate = new Date().toISOString().substr(0, 10);
    },
    stageLocation(searchResult) {
      this.refName = searchResult.location.name;
      this.searchName = searchResult.location.name;
      this.locationId = searchResult.stateLocationId;
      this.search();
      this.togglePopper();
    },
    toggleAdd() {
      this.isAdding = !this.isAdding;
      this.$emit('onEdit');
    },
    togglePopper() {
      this.$refs.locationSearch.showPopper = !this.$refs.locationSearch.showPopper;
    },
    clickPopper() {
      if (this.searchResults === null) {
        this.$refs.locationSearch.showPopper = false;
      } else {
        this.$refs.locationSearch.showPopper = false;
      }
    },
    checkLength() {
      this.resetErrors();
      if (this.searchName === null) {
        this.$refs.locationSearch.showPopper = false;
      } else if (this.searchName.length >= 3) {
        this.$refs.locationSearch.showPopper = true;
        this.search();
      } else {
        this.$refs.locationSearch.showPopper = false;
        this.searchResults = [];
      }
    },
    search() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        try {
          const res = await axios.get(`/location-organizations`, {
            params: {
              q: this.searchName.trim(),
              gid: this.$route.params.groupId,
              childLevel: this.childLevel,
              parentId: this.parentId,
              pageSize: 10,
            },
          });
          this.searchResults = res.data;
        } catch (err) {
          // handle error
        }
      }, 500);
    },
    async addLocation() {
      this.toggleAdd();
      if (this.$route.params.locationId) {
        this.parentId = this.$route.params.locationId;
      } else {
        this.parentId = -1;
      }
      try {
        await axios.post(`/location-groups/${this.$route.params.groupId}/location-group-mappings/`, ({
          locationGroupId: this.$route.params.groupId,
          stateLocationId: this.locationId,
          parentId: this.parentId,
          childLevel: this.childLevel,
          startDate: this.startDate,
        }));
        this.$emit('reloadLocations', this.locationId);
      } catch (error) {
        const { status } = error.response;
        let apiMsg = '';
        if (status === 500) {
          apiMsg = 'Network Error';
        } else if (status === 400) {
          apiMsg = 'Something went wrong.';
        } else {
          apiMsg = `${error.response.data.message}`;
        }
        this.showNotification('danger', [apiMsg]);
      }
    },
    formValidation() {
      this.resetErrors();
      let errors = 0;

      if (!this.searchName) {
        errors += 1;
        this.nameMsg = 'Location is required.';
        this.hasErrorName = true;
      }

      else if (this.locationId == null || this.refName != this.searchName ) {
        errors += 1;
        this.nameMsg = 'Location is invalid.';
        this.hasErrorName = true;
      }

      if (!this.startDate) {
        errors += 1;
        this.dateMsg = 'Start Date is required.';
        this.hasErrorDate = true;
      }

      if (errors === 0) {
        this.addLocation();
      }
    },
    resetErrors() {
      this.hasErrorName = false;
      this.hasErrorDate = false;
      this.nameMsg = null;
      this.dateMsg = null;
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "~bulma/sass/utilities/_all"
  // @import "~bulma/bulma"
  +tablet
    .add-container
      display: flex
    .wrap
      -webkit-flex-wrap: wrap
      flex-wrap: wrap
  .flex-item
    min-width: 155px
    margin: 0rem 1rem 1rem 0rem
    text-align: center
  .popper
    background-color: #fff !important
    -webkit-box-shadow: none !important
    box-shadow: none !important
    width: 100% !important
    padding: 8px 0px !important
    text-align: left
    padding: 0 !important
    .search-result
      font-size: .85rem
      display: flex
      align-items: center
      min-height: 30px
      padding-left: .5rem !important
      padding-right: .5rem !important
      width: 100%
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      &:hover
        background-color: #1E90FF
        color: #fff
    .popper__arrow
      top: 0px
    a
      padding: 4px 24px
      height: 25px
      &:hover
        color: #5953A4 !important
  .align-left
    padding-left: .25rem
    text-align: left
  .align-center
    align-items: center
  .add-container
    padding: .5rem 1rem 0rem
  .grow
    flex-grow: 1
    max-width: 1250px
    min-width: 300px
  .row-add
    border-left: 1px solid #dee2e6
    border-right: 1px solid #dee2e6
    border-top: 2px solid #dee2e6 !important
    border-bottom: 2px solid #dee2e6 !important
    &:hover
      background-color: rgba(89, 83, 164, 0.1) !important
  .field
    // width: 100%
  .field-label
    white-space: nowrap
    flex-grow: 0
  .disabled-icon
    color: #999 !important
    pointer-events: none
  .location-search
    width: 100%
  .breadcrumb
    font-size: .85rem
    a
      &:hover
        text-decoration: none
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    &:hover
      text-decoration:  none
  .w-fixed
    max-width: 140px
  .text-truncate
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .margin25
    margin-top: 0.25em
    margin-left: 0em
  .margin-zero
    margin: 0px
</style>
